import { Injectable } from '@angular/core';
import { Header, Footer, AppScreen } from '../providers/config/config';
import { Nav } from 'ionic-angular';

Injectable()
export class AppState{
    mode = 'app';
    demo: boolean = false;
    appId: number;
    ssoUrl: string = "https://control-us.communico.co/sso/go";
    productType: string;
    newPatronHeader: string = '<h2><i class="am-ok headerCheckmark"></i>Application checklist</h2><ul><li>New Members, 18 years of age or older.</li><li>Valid Email Address required</li><li>Apply online for personal-use cards only.</li><li>Valid ID required for first-time use in a branch.</li></ul>';
    authentication: {
        key: string,
        secret: string
    };
	sharedScreen: boolean;
    searchLinks: Array<any>;
	searchSource: string = "ils";
    header: Header;
    footer: Footer;
    themeRules: any;
    client: any;
    cordovaAvailable: boolean;
    burgerMenu: any;
    nav: Nav;
    eventColors: any;
    staff: boolean;
    patron: any =false;
    cityStateList: boolean = false;
    patronLookupByText: boolean = true;
    loggedInPatronId: number;
    surveyEnabled: boolean;
    scrollArrows: boolean;
    htmlKeyboard: boolean;
    pickupLocations: Array<any>;
    locationId: number;
    branchInformation: any;
    refreshPatron: boolean = false;
    clockEnabledOnScreen: boolean;
    headerLogo: string;
    enableOnScreenKeyboard: boolean;
    autologoutPosition: number;
    cacheTime: number;
    hideHeaderLogo: boolean;
    homeScreen: number;
    boostrapConfig: any;
    currentScreen: AppScreen;
    libraryCardPlaceholderImg: string;
    pinless: boolean;
    enableSounds: boolean;
    directSip2: boolean = false;
    customStrings: any;
    customImages: any;
    logoutSummary: string;
    showNovelistOnLogout: boolean;
    novelistArray: Array<any> = [];
    novelistTimeoutNumber: number;
    selfcheckPayments: boolean;
    receiptTemplates: any;
    preventLogin: boolean = false;
    timeoutEnabled: boolean;
    timeoutInterval: number;
    timeoutWarning: number;
    hideOverviewTab: boolean;
    hideReviewsTab: boolean;
    hasNovelist: boolean;
    pickupLocation: string;
    overrideILSauth: string;
    reverseNameOrder: boolean;
    reserveSignInBookingDate: boolean;
    omitCardFromReserveBooking: boolean;
    disableCartBackdropDismiss: boolean;
    ignorePromptForReceipt: boolean;
    checkingForAnotherPatron: boolean;
    defaultSearchBy: Array<any>;
    searchByList: Array<any>;
    limitByList: Array<any>;
    sortByList: Array<any>;
    roomBooker: boolean;
    disablePrinting: boolean;
    isRoam: boolean;
    isRoamLite: boolean;
    isSelfcheck: boolean;
    physicalScanner: boolean;
    scanIntoPage: string;
    staffCredentials: {
        username: string,
        password: string,
        details?: any
    }
    staffAuthorized: boolean;
    digitalServices: {
        axis360: boolean,
        cloudlibrary: boolean,
        hoopla: boolean,
        overdrive: boolean,
        zinio: boolean,
        bolinda: boolean
    }
    preventAccountEdit: {
        email: boolean,
        phone: boolean,
        address: boolean,
        branch: boolean,
        name: boolean,
        pin: boolean,
        manualBlock: boolean,
        cardCampaign: boolean,
        residentCategory: boolean,
        patronType: boolean,
        noticePreference: boolean,
        dob: boolean
    }
    patronLookupFields: PatronLookUpFields
    recentAccounts: Array<any> = [];
    reserveSignIn: boolean;
    currencyCode: string;
    internationalDate: boolean;
    internationalTime: boolean;
    internationalAddress: boolean;
    homeScanActive: boolean;
    hidePlaceHold: boolean;
    alphanumericPatronBarcode: any;
    patronFields: patronFields;
    showAttendees: boolean;
    disableHomeScreenScanning: boolean;
    showPatronAlerts: boolean;
    showPatronNotes: boolean;
}

export class PatronLookUpFields {
    firstName: boolean = true;
    lastName: boolean = true;
    zip: boolean = true;
}
export type patronFields = {
    [index: string] : patronFieldSettings
}
export type patronFieldSettings = {
    title: string;
    placeholder: string;
    editable: boolean;
    required: boolean;
}


// WEBPACK FOOTER //
// ./src/config/state.ts